<script setup lang="ts">

</script>

<template>
<v-empty-state
  title="Page non trouvé"
  text="La page que vous avez demandé n'existe pas"
/>
</template>

<style scoped>

</style>
